export var ProductTileScreen;
(function (ProductTileScreen) {
    ProductTileScreen["PRODUCT_TILE_SCREEN_UNKNOWN"] = "PRODUCT_TILE_SCREEN_UNKNOWN";
    ProductTileScreen["PRODUCT"] = "PRODUCT";
    ProductTileScreen["BRAND_PAGE"] = "BRAND_PAGE";
    ProductTileScreen["BRAND_PRODUCT_SEARCH_RESULTS"] = "BRAND_PRODUCT_SEARCH_RESULTS";
    ProductTileScreen["CATEGORY_PRODUCT_RESULTS"] = "CATEGORY_PRODUCT_RESULTS";
    ProductTileScreen["BOARDS"] = "BOARDS";
    ProductTileScreen["BUY_AGAIN"] = "BUY_AGAIN";
    ProductTileScreen["CHECKOUT_BRAND"] = "CHECKOUT_BRAND";
    ProductTileScreen["PRODUCT_BASED_COLLECTION"] = "PRODUCT_BASED_COLLECTION";
    ProductTileScreen["BRAND_VIDEO_LIBRARY"] = "BRAND_VIDEO_LIBRARY";
    ProductTileScreen["MY_BRANDS"] = "MY_BRANDS";
    ProductTileScreen["HOME"] = "HOME";
    ProductTileScreen["SEARCH_PRODUCT_RESULTS"] = "SEARCH_PRODUCT_RESULTS";
    ProductTileScreen["ORDER_DETAILS"] = "ORDER_DETAILS";
    ProductTileScreen["NEW_ARRIVALS"] = "NEW_ARRIVALS";
    ProductTileScreen["CART"] = "CART";
    ProductTileScreen["SIMILAR_PRODUCTS"] = "SIMILAR_PRODUCTS";
    ProductTileScreen["POST_ORDER"] = "POST_ORDER";
    ProductTileScreen["DIGEST_PAGE_SCREEN"] = "DIGEST_PAGE_SCREEN";
})(ProductTileScreen || (ProductTileScreen = {}));
